module.exports = __webpack_public_path__ + "img/00001.8938a4ec.webp";